<template>
  <!--header-->
  <div class="box header_train">
    <div class="wrap w1200">
      <div class="col_1 w296 logo" @click="toIndex">
        <img v-if="currentOrg && currentOrg.logo" :src="currentOrg.logo" />
        <img v-if="!currentOrg || !currentOrg.logo" src="./images/logo@2x.png" style="width: auto;" />
      </div>
      <div class="col_2 w810">
        <div class="col_2_2 w140 header_r">
          <div v-if="!token">
            <a @click="toParent('login')" style="cursor: pointer">员工登录</a>
          </div>
          <div class="col_2 top_right_menu" v-if="token">
            <ul>
              <li>
                <label @click="toParent('record')" style="cursor: pointer;"  v-if="isAdmin">{{txt}}</label>
                <ol>
                  <p>
                    <span>
                      <img :src="fuser.head" alt="" v-if="fuser && fuser.head">
                      <img src="./images/member_header.png" title="头像" v-if="!fuser || !fuser.head" />
                      <dl class="kuang_b">
                        <div>
                          <dt>
                            <router-link :to="{path: '/continueEdu/uc/record'}">我的课程</router-link>
                            <router-link :to="{path: '/continueEdu/uc/fav'}" class="icon_b">我的收藏</router-link>
                            <router-link :to="{path: '/continueEdu/uc/examination'}" class="icon_c">我的考试</router-link>
                            <router-link :to="{path: '/continueEdu/uc/enroll'}" class="icon_e">我的报名</router-link>
                            <router-link :to="{path: '/continueEdu/uc/certificate'}" class="icon_d">我的证书</router-link>
                            <router-link :to="{path: '/continueEdu/uc/message'}" class="icon_b">我的消息</router-link>
                            <router-link :to="{path: '/continueEdu/uc/order'}" class="icon_b">我的订单</router-link>
                          </dt>
                          <dd>
                            <router-link :to="{path: '/continueEdu/uc/set'}" class="icon_b">资料设置</router-link>
                            <a href="javascript:void(0);" class="icon_g" @click="toParent('logout')">退出登录</a>
                          </dd>
                        </div>
                      </dl>
                    </span>
                    <span>
                      <span v-if="fuser && fuser.nickname">{{fuser.nickname}}</span><span v-if="!fuser || !fuser.nickname">游客</span><br />
                      <i v-if="currentOrg" class="arrow_i">{{currentOrg.name}}</i>
                      <i v-if="!currentOrg" class="arrow_i">默认机构</i>
                      <div class="arrow_icon"></div>
                      <dl class="kuang_a" v-if="fuser">
                        <div>
                          <div style="height: 220px;">
                            <vue-scroll :ops="ops">
                              <a v-for="org in orgs" :key="org.id" @click="toOtherOrg(org)">
                                <dt>
                                  <img :src="org.logo" alt="" v-if="org.logo">
                                  <img src="./images/jg_icon.jpg" alt="" v-if="!org.logo">
                                  <span v-if="fuser.nickname">{{fuser.nickname}}</span><span v-if="!fuser.nickname">游客</span><br /><b>{{treatName(org.name)}} <span v-if="org.id == getCurrentOrg.id">[当前]</span></b>
                                </dt>
                              </a>
                            </vue-scroll>
                          </div>
                          <dd><!--a>注册新企业</a--></dd>
                        </div>
                      </dl>
                      <dl class="kuang_a" v-else>
                        <div><a href="">暂无企业</a></div>
                        <dd><!--a>注册新企业</a--></dd>
                      </dl>
                    </span>
                  </p>
                </ol>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
  </div>
  <!--/header-->
</template>
<script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import { getCookie } from '@/store/cookies.js'
  import api from '@/api/index'
  import config from '@/config/index'
  import utils from '@/utils'
  export default {
    name: 'Header',
    data () {
      return {
        fuser: {}, // 当前用户
        currentOrg: {}, // 当前机构
        orgs: [], // 机构列表
        ops: {
          vuescroll: {},
          scrollPanel: {},
          rail: {
            background: '#bbb'
          },
          bar: {
            background: '#e73936'
          }
        },
        isAdmin: false
      }
    },
    mounted () {
      this.$VD.setVal('$TOKEN_VAL', getCookie('token'))
      if (getCookie('user')) {
        this.getOrgs(getCookie('user'))
      }
      if (getCookie('org')) {
        this.currentOrg = getCookie('org')
      }
      if (getCookie('token')) {
        this.getRoles() // 当前机构切换以后要重新去取用户角色
      }
    },
    watch: {
      user (val) {
        if (val) {
          this.fuser = val
          this.orgs = val.orgs
        }
      },
      getCurrentOrg (val) {
        if (val) {
          this.currentOrg = val
        }
      },
      getCurrentRoles (val) {
        this.fuser.roleList = utils.grabVal(val, 'role')
        this.isAdmin = this.isPlatAdmin(this.fuser.roleList) || this.isOrgAdmin(this.fuser.roleList) // 是平台管理员或者机构管理员
      }
    },
    computed: {
      ...mapState('auth', ['token', 'user']),
      ...mapGetters('auth', ['getCurrentOrg', 'getCurrentRoles'])
    },
    methods: {
      ...mapActions('auth', {
        getOrgs: 'getOrgs',
        getRoles: 'getRoles',
        setCurrentOrg: 'setCurrentOrg'
      }),
      toParent (page) {
        this.$emit(`to-${page}`)
      },
      toIndex () {
        this.$router.push('/continueEdu/index')
      },
      isPlatAdmin (roles) {
        if (roles) {
          return utils.findElem(roles, 'type', '1') > -1
        }
        return false
      },
      isOrgAdmin (roles) {
        if (roles) {
          return utils.findElem(roles, 'type', '2') > -1
        }
        return false
      },
      treatName (val) {
        return (val.length > 12) ? val.substring(0, 12) : val
      },
      saveUser (org) {
        let o = {
          userId: this.user.id,
          orgId: org.id,
          sign: '2',
          isOpen: org.isOpen
        }
        api.post(config.bylApiPath, '/entUser/save', o, r => {})
      },
      toOtherOrg (org) {
        this.saveUser(org)
        if (org.isOpen == '1') {
          this.setCurrentOrg(org)
        } else if (org.isOpen == '0') {
          this.$toasted.show('机构非公开')
        }
      }
    },
    props: ['txt']
  }
</script>
<style scoped>
  @import './header.css';
</style>



// WEBPACK FOOTER //
// src/components/continueEdu/header/header.vue